export default "__VITE_ASSET__BtdGjdyM__"